import type { Week39PackagingLive } from "./week39-types";

type Entry = Week39PackagingLive["items"][number];
const timestampPattern = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?$/u;
const zonePattern = /(?:Z|[+-]\d{2}:?\d{2})$/u;

function entryTimestamp(value: string): number {
  const normalized = value.replace(" ", "T");
  return Date.parse(zonePattern.test(normalized) ? normalized : `${normalized}+03:00`);
}

export function latestPackagingEntry(live: Week39PackagingLive | null): Entry | null {
  if (!live) return null;
  if (live.latestEntry !== undefined) return live.latestEntry;
  return live.items.filter((item) => item.recordedAt && timestampPattern.test(item.recordedAt) && Number.isFinite(entryTimestamp(item.recordedAt)))
    .sort((a, b) => entryTimestamp(b.recordedAt ?? "") - entryTimestamp(a.recordedAt ?? ""))[0] ?? null;
}

export function entryTimeLabel(recordedAt: string): string {
  const match = timestampPattern.exec(recordedAt);
  if (!match) return "Saat bilinmiyor";
  if (zonePattern.test(recordedAt)) {
    return new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date(recordedAt));
  }
  return `${match[1].slice(8, 10)}.${match[1].slice(5, 7)}.${match[1].slice(0, 4)} ${match[2]}:${match[3]}`;
}
